
import React, { useMemo } from 'react';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { makeStyles } from '@material-ui/core/styles';
import {Grid  , Divider} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import { getAge } from '../calendar';

const useStyles = makeStyles({

    greytypo: {
       color: '#888888' ,
       fontSize :'12px'
     },
    bluetypo: {
        color: '#6a7eff' ,
        fontSize :'12px'
      },
     nametypo: {
         color: '#000000' ,
         fontSize :'18px'
       },
     blacktypo: {
         color: '#000000' ,
         fontSize :'12px'
       },
     redtypo: {
         color: '#ff6a6a' ,
         fontSize :'12px'
       },
    grid: {
        paddingTop : '15px' ,
        paddingBottom : '5px'
    }
   });


const UserCard = ({ record }) => {

    const classes = useStyles();

    const age = useMemo(() => record.birthday ? getAge(record.birthday) : '--', [ record ]); 

    var fav=[];
    fav=fav.concat(record.job);
    if (record.favoriteFood1==1) fav=fav.concat("간이 세지 않은 음식");
    if (record.favoriteFood2==1) fav=fav.concat("먹기에 편한 음식");
    if (record.favoriteFood3==1) fav=fav.concat("비쥬얼이 좋은 음식");
    if (record.favoriteFood4==1) fav=fav.concat("양이 많은 음식");
    if (record.favoriteFood5==1) fav=fav.concat("구성이 탄탄한 음식");
    if (record.favoriteFood6==1) fav=fav.concat("채소 위주의 음식");
    
    return (

    <Grid item xs={12} >
        <div className={classes.grid}>
        <div >
            <span className={classes.nametypo}>{record.name}</span> &nbsp;&nbsp;
            <span>
                <Rating readOnly
                        name="customized-empty"
                        size="small"
                        defaultValue={record.avgRating}
                        precision={0.1}
                        emptyIcon={<StarBorderIcon fontSize="inherit" />}
                /> &nbsp;&nbsp;
            </span>
            <span className={classes.blacktypo}>평균평점 <b>{record.avgRating}</b></span>&nbsp;&nbsp;
            <span className={classes.blacktypo}><b>{record.totalCount}</b> 식수량 중 <b>{record.totalReview}</b>개의 평가</span>
        </div>
        <br />
        <div >
            <span className={classes.bluetypo}>{record.gender}</span>&nbsp;&nbsp;
            <span className={classes.greytypo}>{age}세</span>&nbsp;&nbsp;
            <span className={classes.greytypo}>
            {
                fav.map((rows) => (
                <Chip label={rows} variant="outlined" size="small" />
                ))
            }
            </span>
        </div>
        </div>
        <Divider />
    </Grid>
    ) 
    };  
    
export default UserCard;